module.exports = __webpack_public_path__ + "img/escaner11.47c4405f.webp";